import type { HitProps } from '@components/algolia/Hit';

/**
 * The colour key for an authored variant SKU. `variants` is keyed by colour, so
 * the SKU has to be looked up before `useHitSwatches` runs — the hook selects by
 * colour, not by SKU. Falls back to the record's own colour when the SKU is
 * absent or unknown, so a stale SKU degrades to the default colourway rather
 * than dropping the card/hotspot.
 */
export const colourKeyForVariantSku = (
  record: HitProps,
  variantSku: string | null | undefined
): string => {
  const sku = variantSku?.trim();

  if (!sku) {
    return record.colour;
  }

  const match = Object.entries(record.variants ?? {}).find(
    ([, variant]) => variant?.sku === sku
  );

  return match?.[0] ?? record.colour;
};

export default colourKeyForVariantSku;
